import { PlanFormContainer } from "./components/form/PlanFormContainer";

interface WorkoutPlanFormProps {
  onPlanAdded: () => void;
}

export const WorkoutPlanForm = ({ onPlanAdded }: WorkoutPlanFormProps) => {
  return <PlanFormContainer onPlanAdded={onPlanAdded} />;
};